var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBioWizardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50002 0.166687C7.33987 0.166687 8.14533 0.500317 8.73919 1.09418C9.33306 1.68805 9.66669 2.4935 9.66669 3.33335C9.66669 4.17321 9.33306 4.97866 8.73919 5.57252C8.14533 6.16639 7.33987 6.50002 6.50002 6.50002C5.66017 6.50002 4.85471 6.16639 4.26085 5.57252C3.66698 4.97866 3.33335 4.17321 3.33335 3.33335C3.33335 2.4935 3.66698 1.68805 4.26085 1.09418C4.85471 0.500317 5.66017 0.166687 6.50002 0.166687ZM6.50002 1.75002C6.08009 1.75002 5.67737 1.91684 5.38043 2.21377C5.0835 2.5107 4.91669 2.91343 4.91669 3.33335C4.91669 3.75328 5.0835 4.15601 5.38043 4.45294C5.67737 4.74987 6.08009 4.91669 6.50002 4.91669C6.91995 4.91669 7.32267 4.74987 7.61961 4.45294C7.91654 4.15601 8.08335 3.75328 8.08335 3.33335C8.08335 2.91343 7.91654 2.5107 7.61961 2.21377C7.32267 1.91684 6.91995 1.75002 6.50002 1.75002ZM6.50002 7.29169C8.61377 7.29169 12.8334 8.3446 12.8334 10.4584V12.8334H0.166687V10.4584C0.166687 8.3446 4.38627 7.29169 6.50002 7.29169ZM6.50002 8.79585C4.14877 8.79585 1.67085 9.95169 1.67085 10.4584V11.3292H11.3292V10.4584C11.3292 9.95169 8.85127 8.79585 6.50002 8.79585Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioWizardIcon);
export default __webpack_public_path__ + "static/media/bio-wizard-icon.9d7cbb8b.svg";
export { ForwardRef as ReactComponent };